module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/label_question.2a746.png";